import { useTranslation } from 'react-i18next'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useMediaQuery } from 'usehooks-ts'

import styles from './styles.module.scss'

const data = [
  { title: 'services.1', img: '1.jpg' },
  { title: 'services.2', img: '2.jpg' },
  { title: 'services.3', img: '3.jpg' },
  { title: 'services.4', img: '4.jpg' },
]

function ServiceCard ({ title, img }: { title: string; img: string }) {
  const { t: ta } = useTranslation('about')
  return (
    <div className={styles.root__item}>
      <h3 className={styles.root__subtitle}>{ta(title)}</h3>
      <img src={`img/services/${img}`} alt="" />
    </div>
  )
}

export default function Services () {
  const { t: ta } = useTranslation('about')
  const isTablet = useMediaQuery('(max-width: 767px)')

  return (
    <div className={styles.root}>
      <h3 className={styles.root__title}>{ta('services.title')}</h3>

      {isTablet ? (
        <Swiper slidesPerView="auto" spaceBetween={8}>
          {data.map((item, index) => (
            <SwiperSlide key={index} className={styles.root__slide}>
              <ServiceCard title={item.title} img={item.img} />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div className={styles.root__list}>
          {data.map((item, index) => (
            <ServiceCard key={index} title={item.title} img={item.img} />
          ))}
        </div>
      )}
    </div>
  )
}
